export const calendarStrings = {
	sameDay: "[Today at] h:mm A", // The same day (Today at 2:30 AM)
	nextDay: "[Tomorrow at] h:mm A", // The next day (Tomorrow at 2:30 AM)
	lastDay: "[Yesterday at] h:mm A", // The day before (Yesterday at 2:30 AM)
	lastWeek: "[Last] dddd [at] h:mm A", // Last week (Last Monday at 2:30 AM)
	sameElse: "MM/DD/YYYY h:mm A", // Everything else (01/19/2018 2:30 AM)
};
